import React, { ReactElement } from 'react';
import { useMessage } from '@messageformat/react';
import { Select, uniqueId } from '@op/opds.opux';
import { space } from '@op/opds.tokens';

interface QuestionProps {
  options: string[];
  selectedOptions: string[];
  index: number;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  label: string;
}

const Selection = ({
  options,
  selectedOptions,
  index,
  onChange,
  label,
}: QuestionProps): ReactElement => {
  const [id] = React.useState(uniqueId('course3-selection-'));
  const notSelectedOptions: string[] = options.filter((element: string) => {
    return !selectedOptions.includes(element);
  });
  const alreadySelectedOptions: string[] = options.filter((element: string) => {
    return selectedOptions.includes(element);
  });
  const currentValue: string = selectedOptions[index] || 'default';

  const selectDefaultOption = useMessage('select_default_option');
  const notYetSelectedLabel = useMessage('not_yet_selected');
  const alreadySelectedLabel = useMessage('already_selected');

  return (
    <>
      <label htmlFor={id} className="opds-styles-v1-text-label-small">
        {label}
      </label>
      <Select
        style={{
          marginTop: space.xxs,
        }}
        value={currentValue}
        onChange={onChange}
        id={id}
      >
        <option value="default" label={selectDefaultOption} />
        {notSelectedOptions.length > 0 && (
          <optgroup label={notYetSelectedLabel}>
            {notSelectedOptions.map((element: string) => {
              return (
                <option value={element} key={`selected-${element}`}>
                  {element}
                </option>
              );
            })}
          </optgroup>
        )}
        {alreadySelectedOptions.length > 0 && (
          <optgroup label={alreadySelectedLabel}>
            {alreadySelectedOptions.map((element: string) => {
              return (
                <option value={element} key={`selected-${element}`}>
                  {element}
                </option>
              );
            })}
          </optgroup>
        )}
      </Select>
    </>
  );
};

export default Selection;
